import { Injectable, inject } from '@angular/core';
import { CrudService } from '@shared/modules/crud/crud.service';
import { map, Observable } from 'rxjs';
import { MODEL } from './parametry.config';
import { Pricing, PRICING_DOC } from './pricing.config';

//lee parametry/pricing (precios del abono, paquetes por categoría e IVA, AF319). Solo lectura: se edita en la consola de Firebase
@Injectable({
    providedIn: 'root',
})
export class PricingService {
    crudService = inject(CrudService);

    get(): Observable<Pricing | null> {
        this.crudService.setModel(MODEL);
        //si el documento no existe llega undefined: se devuelve null para distinguirlo de "todavía cargando"
        return this.crudService.findFirst<any>(PRICING_DOC).pipe(map((pricing) => (pricing ?? null) as Pricing | null));
    }
}
